import React, { useEffect } from 'react';
import {withStyles} from '@material-ui/core/styles';

const styles = theme => ( {
  root: {
    position: "relative",
    width: "100%"
  },
  display: {
    position: "absolute",
    top: 2,
    left: 0,
    bottom: 2,
    background: "white",
    pointerEvents: "none",
    right: 50,
    display: "flex",
    alignItems: "center"
  },
  input: {}
});

const DateInputComponent = ({ defaultValue, inputRef, ...props }) => {
  const { classes } = props;
  const [value, setValue] = React.useState(() => props.value || defaultValue);

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  
  const handleChange = event => {
    setValue(event.target.value);
    if (props.onChange) {
      props.onChange(event);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.display}>{value}</div>
      <input
        className={classes.input}
        ref={inputRef}
        {...props}
        onChange={handleChange}
        value={value}
      />
    </div>
  );
};

export default withStyles( styles )( DateInputComponent );
